import T from "i18n-react";

export const prepareField = (fieldValue) => {
    if (fieldValue != null && fieldValue !== '') {
        return fieldValue.toLowerCase().replace(' ', '');
    }
    return 'none';
}

export const mapCountry = (country) => {
    const countryToBeMapped = prepareField(country);

    return T.translate('vinSearchReducer.' + countryToBeMapped) || '-';
}

export const prepareClaimData = ({vin, reportData, setDownloadButtonLoader}) => {
    return {
        vin: vin,
        reportData: reportData,
        year: reportData.firstRegistrationDate || '',
        engineDisplacement: reportData.engineCC || '',
        records: reportData.resultList?.map(result => {
            return {
                ...result,
                ...result.fields,
                fields: null,
                country: result.country ? T.translate(`vinSearchReducer.${result.country.toLowerCase()}`) : result.country,
                highestBid: result.fields.highestBid,
                expirationDate: result.fields.expirationDate,
                bidCurrency: result.fields.bidCurrency,
                claimType: T.translate('vinSearchReducer.' + prepareField(result.fields.claimType), {notFound: result.fields.claimType}),
                customerRole: T.translate('vinSearchReducer.' + prepareField(result.fields.customerRole), {notFound: result.fields.customerRole}),
                fuelLabel: T.translate('vinSearchReducer.' + prepareField(result.fields.fuelLabel), {notFound: result.fields.fuelLabel}),
                color: result.fields.color,
                insuranceCountry: T.translate('vinSearchReducer.' + prepareField(result.fields.insuranceCountry)),
                subscriptionTitle: result.fields.subscriptionTitle,
            };
        }),
        setLoader: setDownloadButtonLoader,
    };
}

export const downloadBase64 = (fileSettings) => {
    // Convert base64 to a Blob
    const byteCharacters = atob(fileSettings.base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileSettings.dataType });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileSettings.fileName;

    // Append the link to the body
    document.body.appendChild(link);

    // Trigger the download by simulating a click
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);
};